import { formatISO, parseISO } from "date-fns";

export const END_OF_TODAY_DATE = new Date();
END_OF_TODAY_DATE.setHours(23, 59, 59, 999);

export const START_OF_TODAY_DATE = new Date();
START_OF_TODAY_DATE.setHours(0, 0, 0, 0);

export const isValidDate = (date: Date): boolean => {
  return !Number.isNaN(Number(date));
};

/**
 * Converts a Date object to an ISO date string.
 *
 * @param date - The date object to convert
 * @returns - An ISO date string with no time component or null if invalid date is passed.
 */
export const toISODate = (date: Date | null | undefined): string | null => {
  if (date === null || date === undefined || !isValidDate(date)) {
    return null;
  }

  return formatISO(date, { representation: "date" });
};

/**
 * Converts a string date into a Date object or null. MAinly for use with MUI Date Picker
 *
 * @param date - The string representation of the date to convert.
 * @return - The converted Date object, or null if the input is invalid or null.
 */
export const dateOrNull = (date: string | null | undefined): Date | null => {
  if (!date) {
    return null;
  }

  const parsedDate = parseISO(date);

  if (String(parsedDate) !== "Invalid Date") {
    return parsedDate;
  }

  return null;
};
